import { TrendingUp } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import SectorGroups from "./SectorGroups";
import { useLanguage } from "@/i18n";

export default function CaseStudies() {
    const { t } = useLanguage();

    return (
        <section
            id="casi"
            data-testid="cases-section"
            className="relative scroll-mt-20 border-t border-navy-600"
        >
            <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
                <SectionHeading
                    chapter={t.cases.chapter}
                    eyebrow={t.cases.eyebrow}
                    title={t.cases.title}
                    description={t.cases.description}
                    testid="cases-heading"
                />

                <div className="mb-14 lg:mb-16">
                    <SectorGroups testid="cases-sector-groups" />
                </div>

                <div className="grid gap-4 lg:grid-cols-3">
                    {t.cases.items.map((c, i) => (
                        <Reveal key={c.id} delay={i * 0.08} className="h-full">
                            <article
                                data-testid={`case-card-${c.id}`}
                                className="flex h-full flex-col border border-navy-600 bg-navy-950 p-6 transition-colors hover:border-sky-400 sm:p-8"
                            >
                                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-sky-400">
                                    {c.sector}
                                </p>
                                <h3 className="mt-3 font-display text-xl font-semibold tracking-tight text-slate-50 sm:text-2xl">
                                    {c.title}
                                </h3>
                                <p className="mt-5 text-sm leading-relaxed text-slate-400">
                                    <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">
                                        {t.cases.contextLabel} —{" "}
                                    </span>
                                    {c.context}
                                </p>
                                <p className="mt-3 text-sm leading-relaxed text-slate-400">
                                    <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500">
                                        {t.cases.actionLabel} —{" "}
                                    </span>
                                    {c.action}
                                </p>
                                <div className="flex-1" />
                                <div className="mt-6 border-t border-navy-600/70 pt-6">
                                    <p className="mb-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
                                        <TrendingUp className="h-3.5 w-3.5 text-emerald-400" />
                                        {t.cases.resultsLabel}
                                    </p>
                                    <div className="grid grid-cols-3 gap-3">
                                        {c.results.map((r, ri) => (
                                            <div key={ri} data-testid={`case-${c.id}-result-${ri + 1}`}>
                                                <p className="font-display text-xl font-bold text-sky-400 sm:text-2xl">
                                                    {r.value}
                                                </p>
                                                <p className="mt-1 text-[11px] leading-tight text-slate-500">{r.label}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
